module.exports = __webpack_public_path__ + "static/media/5DPO9.8d44a8a2.jpg";